import type { components } from '@fluencelabs/vodopad-admin-api'
import { Button, Space } from 'antd'
import { useState } from 'react'

import { DetachPublicIpButton } from '@/components/common/DetachPublicIpButton'
import { PublicIpLink, usePublicIp } from '@/components/common/PublicIpLink'
import { VM_TERMINAL_STATUSES } from '@/constants/statuses'

import { AttachPublicIpModal } from './AttachPublicIpModal'

type UserVmDto = components['schemas']['AdminUserVmDto']

interface Props {
  vm: UserVmDto
  onChanged: () => void
}

export function VmPublicIpField({ vm, onChanged }: Props) {
  const [attachOpen, setAttachOpen] = useState(false)
  const disabled = VM_TERMINAL_STATUSES.has(vm.status)
  const ip = usePublicIp(vm.publicIp)

  return (
    <>
      <Space wrap>
        {vm.publicIp ? (
          <>
            <PublicIpLink publicIpId={vm.publicIp} />
            <DetachPublicIpButton
              vmId={vm.id}
              ipLabel={ip?.address ?? ip?.name ?? vm.publicIp}
              vmLabel={vm.name}
              disabled={disabled}
              onDetached={onChanged}
            />
          </>
        ) : (
          <>
            —
            <Button
              size="small"
              disabled={disabled}
              onClick={() => setAttachOpen(true)}
            >
              Attach IP
            </Button>
          </>
        )}
      </Space>
      <AttachPublicIpModal
        vm={vm}
        open={attachOpen}
        onClose={() => setAttachOpen(false)}
        onAttached={onChanged}
      />
    </>
  )
}
